// eslint-disable-next-line import/prefer-default-export
export const timezoneDisplayName = (ianaTimezone, allTimezones) => {
  const tz = allTimezones.filter(tzi => tzi.value === ianaTimezone)[0];
  return tz ? tz.label : null;
};



// WEBPACK FOOTER //
// ./src/utils/timezoneUtils.js